// for employee information
export const EMPLOYEE_INFO = "employee_info";
export const EMPLOYEE_INFO_SUCCESS = "employee_info_success";
export const EMPLOYEE_INFO_FAILURE = "employee_info_failure";
